export const TOKEN_KEY = 'token';
export const REFRESH_TOKEN_KEY = 'refreshToken';
export const REMEMBER_ME_KEY = 'rememberMe';
